import {useCallback, useMemo} from 'react';

import {parseStoredStringList, toggleListItem} from '@/utils';

import {useJsonStorage} from './useJsonStorage';

const NONE_COLLAPSED: string[] = [];

export interface CollapsedKeys {
  isCollapsed: (key: string) => boolean;
  toggle: (key: string) => void;
}

/** Which keys the reader folded, remembered in the browser under `storageKey`; everything starts expanded. */
export function useCollapsedKeys(storageKey: string): CollapsedKeys {
  const [collapsed, setCollapsed] = useJsonStorage(
    storageKey,
    NONE_COLLAPSED,
    parseStoredStringList
  );
  const collapsedSet = useMemo(() => new Set(collapsed), [collapsed]);

  const toggle = useCallback(
    (key: string) => setCollapsed(previous => toggleListItem(previous, key)),
    [setCollapsed]
  );
  const isCollapsed = useCallback((key: string) => collapsedSet.has(key), [collapsedSet]);

  return useMemo(() => ({isCollapsed, toggle}), [isCollapsed, toggle]);
}
